import ngTranslate from 'angular-translate';

import errorCodeTranslationsPriority from '@jht/translations-loader?includeLang=priority!../../error_code_translations.csv';

const translation = angular.module('translation', [ngTranslate])
.config(function($translateProvider, configProvider) {
    var config = configProvider.$get();

    // angular-translate's sanitization strategy is completely, hopelessly broken
    $translateProvider.useSanitizeValueStrategy(null);

    $translateProvider.useLoader('customTranslationLoader');

    // Register main Priority translations
    $translateProvider.translations('priority', errorCodeTranslationsPriority.priority);

    $translateProvider
    .registerAvailableLanguageKeys(config.availableLanguages, config.languageAliases)
    .fallbackLanguage(config.defaultLanguage)
    .determinePreferredLanguage();

});

translation.factory('customTranslationLoader', function($http, $q, config) {
    // return loaderFn
    return function(options) {
        return $http.get(config.apiUrl + '/translations/' + options.key)
        .then((response) => {
            return angular.extend({}, response.data);
        })
        .catch(() => {
            // Bare minimum to display maintenance mode in english
            return {
                APPLICATION_NAME: 'Asset Management 4',
                MAINTENANCE_TITLE: 'Maintenance',
                ERROR_MESSAGE_MAINTENANCE: 'AM4 is undergoing planned maintenance',
                REFRESH_THE_PAGE: 'Please refresh the page.'
            };
        });
    };
});

export default translation;



// WEBPACK FOOTER //
// ./src/app/translation.js